import Button from '@material-ui/core/Button/Button';
import Menu from '@material-ui/core/Menu/Menu';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import ConfirmLogout from 'packages/dialogs/ConfirmLogout';
import Settings from 'packages/dialogs/settings/Settings';
import {useModal} from 'packages/hooks/use-modal';
import React from 'react';
import useStyles from '../admin-styles';

const AccountLogout = () => {
  const classes = useStyles();
  const {toggle, modalOpen} = useModal();
  const {toggle: toggleSettings, modalOpen: settingOpen} = useModal();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenSettings = () => {
    handleClose();
    toggleSettings();
  };

  return (
    <>
      <Settings toggle={toggleSettings} modalOpen={settingOpen} />
      <ConfirmLogout toggle={toggle} modalOpen={modalOpen} />
      <Button
        className={classes.acl_button}
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        Tu Cuenta
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleOpenSettings}>Patrocinadores</MenuItem>
        <MenuItem onClick={toggle}>Cerrar sesión</MenuItem>
      </Menu>
    </>
  );
};

export default AccountLogout;
